<template>
    <app-layout title="Add Announcement">
        <form @submit.prevent="form.post(route('announcements.store'))">
            <page-header>
                <template #title>Add Announcement</template>

                <template #actions>
                    <jet-button v-show="form.isDirty" type="submit" :disabled="form.processing" >
                        Save
                    </jet-button>

                    <jet-tertiary-button :disabled="form.processing" :href="route('announcements.index')">
                        Cancel
                    </jet-tertiary-button>
                </template>
            </page-header>

            <announcement-form
                :form="form"
                :pricingLevelOptions="pricingLevelOptions"
                class="px-2 md:px-4 lg:px-8"
            />
        </form>

        <jet-confirmation-modal :show="showCancelModal" @close="showCancelModal=false">
            <template #title>
                Cancel without saving?
            </template>

            <template #content>
                Announcement has not been saved yet, are you sure you would like to cancel?
            </template>

            <template #footer>
                <jet-tertiary-button @click="showCancelModal=false">
                    No
                </jet-tertiary-button>

                <jet-danger-button class="ml-2" @click="cancelCreate" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    Yes
                </jet-danger-button>
            </template>
        </jet-confirmation-modal>
    </app-layout>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3'
import AnnouncementForm from '@/Pages/Announcements/Partials/AnnouncementForm.vue';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import JetButton from '@/Jetstream/Button';
import JetConfirmationModal from '@/Jetstream/ConfirmationModal';
import JetDangerButton from '@/Jetstream/DangerButton';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';

export default {
    setup () {
        const form = useForm({
            id: null,
            pricing_level_ids: [],
            message: '',
        })

        return { form }
    },

    components: {
        AnnouncementForm,
        AppLayout,
        PageHeader,
        JetButton,
        JetConfirmationModal,
        JetDangerButton,
        JetTertiaryButton,
    },

    props: [
        'pricingLevelOptions'
    ],

    data() {
        return {
            showCancelModal: false,
        }
    },

    methods: {
        cancelCreate() {
            this.$inertia.get(route('announcements.index'));
        },
    }
}
</script>

<style scoped>
.multi-custom {
    min-height: 1.5rem;
}
</style>